// The chat's client-side rules. core.md §8.4, §9.5.
//
// v1 replayed the last 12 turns from the CLIENT with every question. v2 does
// not: the store's thread IS the memory and the BFF replays the last 12 turns
// itself (core.md §2.2), so `conversationHistory` is gone from the schema and
// so is the replay code that fed it. What is left is what the client still has
// to know before it spends پارسه.

/** The AI service reserves `__DIFF_REFINE__` / `__SOAP_REFINE__` as bypass prefixes. */
export const isReservedQuestion = (q) => /^\s*__/.test(String(q ?? ''));

/** The composer's hard cap; the BFF rejects longer with INVALID_INPUT. */
export const MAX_QUESTION_CHARS = 4000;

/** The counter appears past this many characters. */
export const COUNTER_FROM_CHARS = 3500;

/** `empty` | `reserved` | `tooLong` | null — the one client-side validation. */
export function questionProblem(q) {
  const text = String(q ?? '');
  if (!text.trim()) return 'empty';
  if (isReservedQuestion(text)) return 'reserved';
  if (text.length > MAX_QUESTION_CHARS) return 'tooLong';
  return null;
}

/**
 * A thread's automatic title — the first question, clipped at 60 chars
 * (core.md §9.5). The BFF stores exactly this (`src/lib/threadTitle.js` there),
 * and this copy exists for the OPTIMISTIC title the header shows while the first
 * answer is in flight: the two must agree, or the title flashes when it lands.
 */
export const AUTO_TITLE_CHARS = 60;
export function autoTitle(question) {
  const text = String(question ?? '').replace(/\s+/g, ' ').trim();
  if (text.length <= AUTO_TITLE_CHARS) return text;
  return text.slice(0, AUTO_TITLE_CHARS).trimEnd();
}

/** A message's display title: its own, or the auto title from its first question. */
export const threadTitle = (thread, fallback = '') => String(thread?.title ?? '').trim() || fallback;
